import defaultCola from "../data/default-cola.json";

/**
 * Compute the cumulative lifetime Social Security benefit assuming an annual COLA
 * is applied at the start of each year after the claim year.
 *
 * Inputs:
 *   monthlyBenefitInitial - first-month benefit at claim age
 *   claimAgeMonths        - claim age in whole months from birth
 *   longevityAgeMonths    - assumed death age in whole months from birth (exclusive: benefit paid through this month)
 *   colaRate              - annual COLA as a decimal (e.g., 0.025)
 *
 * Returns the sum of all monthly benefits paid from claimAgeMonths to longevityAgeMonths,
 * with the benefit growing by (1 + colaRate) at each 12-month boundary.
 */
export function cumulativeWithCola(params: {
  monthlyBenefitInitial: number;
  claimAgeMonths: number;
  longevityAgeMonths: number;
  colaRate: number;
}): number {
  const { monthlyBenefitInitial, claimAgeMonths, longevityAgeMonths, colaRate } = params;
  if (longevityAgeMonths <= claimAgeMonths) return 0;

  let total = 0;
  let currentMonthly = monthlyBenefitInitial;
  const monthsPaid = longevityAgeMonths - claimAgeMonths;
  for (let m = 0; m < monthsPaid; m++) {
    total += currentMonthly;
    if ((m + 1) % 12 === 0) {
      currentMonthly *= 1 + colaRate;
    }
  }
  return total;
}

export function getDefaultColaRate(): number {
  return defaultCola.assumed_annual_rate;
}

export function getColaDefaultVerified(): string {
  return defaultCola.last_verified;
}
